import React, { FC } from 'react';

import { mqMin } from '@lucid/theme';

import { LucidTheme } from '../../types/types';
import Box from '../box/box';
import Container from '../container/container';
import Heading from '../heading/heading';
import Link from '../link/link';

export interface AdditionalResource {
  fieldResourceText?: string;
  fieldResourceUrl?: string;
}

export interface AdditionalResourcesProps {
  resources: AdditionalResource[];
  blurb?: string | null | undefined;
  ctaPath?: string | undefined;
  sectionHeading?: string;
  blurbText?: string;
  contactSalesText?: string;
}

const AdditionalResources: FC<AdditionalResourcesProps> = ({
  blurb,
  ctaPath,
  sectionHeading,
  blurbText,
  contactSalesText,
  resources,
}) => {
  return (
    <Box
      as="section"
      css={(theme: LucidTheme) => ({
        backgroundColor: theme.colors.coolGrey[90],
        backgroundImage:
          'url("https://d2slcw3kip6qmk.cloudfront.net/marketing/pages/chart/consideration/background/footer-background.png")',
        backgroundPositionX: '-120px',
        backgroundPositionY: '40%',
        backgroundSize: '100%',
        color: theme.colors.white,
        padding: `${theme.space.s64}px 0`,
      })}
    >
      <Container displayFlex css={{ flexWrap: 'wrap' }}>
        <Box flex={{ default: '0 1 100%', tabletSmall: '0 1 41.6%' }} mb={4}>
          <Heading
            as="h2"
            css={(theme: LucidTheme) => ({
              color: theme.colors.white,
              marginTop: 0,
            })}
            variant="headlineM"
          >
            {sectionHeading}
          </Heading>
          <ul css={{ margin: 0, padding: 0, listStyle: 'none' }}>
            {resources
              .filter(ar => ar.fieldResourceUrl)
              .map(ar => {
                return (
                  <li key={ar.fieldResourceText}>
                    <Link
                      css={(theme: LucidTheme) => ({
                        marginBottom: theme.space.s8,
                        fontSize: theme.fontSizes.fs20,
                      })}
                      to={ar.fieldResourceUrl!}
                      variant="hasDarkBackground"
                    >
                      {ar.fieldResourceText}
                    </Link>
                  </li>
                );
              })}
          </ul>
        </Box>
        <Box flex={{ default: '0 1 100%', tabletSmall: '0 1 55.3%' }}>
          <Heading
            as="h2"
            color="white"
            css={(theme: LucidTheme) => ({
              marginTop: theme.space.s32,
              marginBottom: theme.space.s16,
              [mqMin.tabletSmall]: {
                marginTop: 0,
              },
            })}
            variant="headlineXL"
          >
            {blurb || blurbText}
          </Heading>
          <Link displayAsButton to={ctaPath} variant="secondary">
            {contactSalesText}
          </Link>
        </Box>
      </Container>
    </Box>
  );
};

export default AdditionalResources;
